import type { IGetProductsQuery } from "@magento/types/CodegenTypes";
import { ICurrencyEnum, IProductStockStatus } from "@magento/types/CodegenTypes";

export const getSimpleProductResponseMock = (): IGetProductsQuery => ({
  currency: {
    base_currency_code: ICurrencyEnum.Eur,
    base_currency_symbol: "€",
  },
  products: {
    aggregations: [
      {
        attribute_code: "price",
        label: "Price",
        options: [
          {
            count: 1,
            label: "2-3",
            value: "2_3",
          },
        ],
      },
      {
        attribute_code: "category_uid",
        label: "Category",
        options: [
          {
            count: 1,
            label: "Acquista",
            value: "NDI=",
          },
        ],
      },
      {
        attribute_code: "flavor",
        label: "Flavor",
        options: [
          {
            count: 1,
            label: "Mint",
            value: "37",
          },
        ],
      },
      {
        attribute_code: "color",
        label: "Colour",
        options: [
          {
            count: 1,
            label: "Diamond",
            value: "38",
          },
        ],
      },
    ],
    items: [
      {
        sku: "test-sku",
        __typename: "SimpleProduct",
        id: 6471,
        product_disclaimer: "",
        name: "Test Simple NDev 01s",
        product_brand: "1",
        stock_status: IProductStockStatus.InStock,
        flavor: 37,
        flavor_label: "Banana Flavor",
        color: 38,
        thumbnail: {
          url: "https://m24-fe1.dev-jtides.com/static/version1732026409/frontend/Magento/luma/en_US/Magento_Catalog/images/product/placeholder/thumbnail.jpg",
        },
        subtitle: "Subtitle",
        categories: [
          {
            name: "Acquista",
          },
        ],
        price_tiers: [
          {
            quantity: 10,
            discount: {
              percent_off: 30,
              amount_off: 0.6,
            },
            final_price: {
              value: 1.4,
              currency: ICurrencyEnum.Eur,
            },
            total_price: {
              value: 14,
              currency: ICurrencyEnum.Eur,
            },
            label: "even more",
          },
          {
            quantity: 20,
            discount: {
              percent_off: 30.5,
              amount_off: 0.61,
            },
            final_price: {
              value: 1.39,
              currency: ICurrencyEnum.Eur,
            },
            total_price: {
              value: 27.8,
              currency: ICurrencyEnum.Eur,
            },
            label: "even more 2",
          },
          {
            quantity: 50,
            discount: {
              percent_off: 32.5,
              amount_off: 0.65,
            },
            final_price: {
              value: 1.35,
              currency: ICurrencyEnum.Eur,
            },
            total_price: {
              value: 67.5,
              currency: ICurrencyEnum.Eur,
            },
            label: "",
          },
        ],
        price_range: {
          minimum_price: {
            final_prices: [
              {
                value: 10,
                currency: ICurrencyEnum.Eur,
                multiplier: 1,
              },
              {
                value: 20,
                currency: ICurrencyEnum.Eur,
                multiplier: 2,
              },
              {
                value: 30,
                currency: ICurrencyEnum.Eur,
                multiplier: 3,
              },
              {
                value: 40,
                currency: ICurrencyEnum.Eur,
                multiplier: 4,
              },
              {
                value: 50,
                currency: ICurrencyEnum.Eur,
                multiplier: 5,
              },
            ],
            final_price: {
              value: 80,
              currency: ICurrencyEnum.Eur,
            },
            regular_price: {
              value: 80,
              currency: ICurrencyEnum.Eur,
            },
            discount: {
              percent_off: 0,
            },
          },
        },
        media_gallery: [],
        flavour_details: [],
      },
    ],
  },
});
